import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store';

const NAV = [
  { icon: '🏠', label: 'View Site', path: '/' },
  { icon: '📊', label: 'Dashboard', path: '/admin' },
  { icon: '🏫', label: 'Schools', path: '/admin/schools' },
  { icon: '🎒', label: 'Kits', path: '/admin/kits' },
  { icon: '📦', label: 'Products', path: '/admin/products' },
  { icon: '📁', label: 'Categories', path: '/admin/categories' },
  { icon: '🧾', label: 'Orders', path: '/admin/orders' },
  { icon: '🌍', label: 'Tax Rates', path: '/admin/tax-rates' },
  { icon: '🚚', label: 'Shipping Discounts', path: '/admin/shipping-discounts' },
  { icon: '📋', label: 'School Requests', path: '/admin/school-requests' },
  { icon: '👥', label: 'Customers', path: '/admin/customers' },
  { icon: '💰', label: 'Price Comparison', path: '/admin/price-comparison' },
];

const AdminLayout = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  if (!user || user.role !== 'admin') {
    navigate('/login');
    return null;
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={styles.sidebar}>
        <div style={styles.sidebarLogo}>🎒 Admin</div>
        <nav style={{ flex: 1 }}>
          {NAV.map(n => (
            <NavLink
              key={n.path}
              to={n.path}
              end={n.path === '/admin' || n.path === '/'}
              style={({ isActive }) => ({
                ...styles.navLink,
                ...(isActive ? styles.navLinkActive : {}),
              })}
            >
              <span>{n.icon}</span> {n.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '1rem' }}>
          <div style={{ fontSize: '0.78rem', color: '#9ca3af', marginBottom: '0.4rem' }}>{user.email}</div>
          <button
            className="btn btn-sm btn-full"
            style={{ background: '#374151', color: '#fff' }}
            onClick={() => { logout(); navigate('/'); }}
          >
            Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, padding: '1.5rem', overflow: 'auto', background: '#f9fafb' }}>
        <Outlet />
      </main>
    </div>
  );
};

const styles = {
  sidebar: {
    width: 220, background: '#1f2937', color: '#f9fafb',
    display: 'flex', flexDirection: 'column', position: 'sticky', top: 0, height: '100vh',
  },
  sidebarLogo: { padding: '1.25rem 1rem', fontWeight: 900, fontSize: '1.15rem', borderBottom: '1px solid #374151' },
  navLink: {
    display: 'flex', alignItems: 'center', gap: '0.6rem',
    padding: '0.65rem 1rem', fontSize: '0.9rem', color: '#d1d5db',
    transition: 'background 0.15s', textDecoration: 'none',
  },
  navLinkActive: { background: '#2563eb', color: '#fff', fontWeight: 700 },
};

export default AdminLayout;
